import React, { useContext } from 'react'
import RmdCheckbox, { CheckboxProps } from 'react-md/lib/SelectionControls/Checkbox'
import styled, { ThemeContext } from 'styled-components'
import UncheckedCheckboxIcon from 'assets/icons/checkbox-unchecked.svg'
import SvgCheckboxCheckedIcon from 'assets/icons/CheckboxChecked'

const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps) => {
  const theme = useContext(ThemeContext)

  return (
    <StyledCheckbox
      {...props}
      checkedIcon={<SvgCheckboxCheckedIcon fill={theme.colors.main} />}
      uncheckedIcon={<img src={UncheckedCheckboxIcon} />}
    />
  )
}

const StyledCheckbox = styled(RmdCheckbox)`
  height: unset;

  .md-selection-control-toggle {
    width: 30px;
    height: 20px;
    padding: 0 10px 0 0;
  }

  ${({ disabled }) => disabled ? `
    label {
      opacity: 0.7;
      cursor: not-allowed;
    }
  `: ''}

  span {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.secondary};
  }
`

export default Checkbox
